import { defineMessages } from 'react-intl';

export const freightSettingsMessages = defineMessages({
  pageTitle: {
    description: 'Title for the freight settings page',
    defaultMessage: 'WWEX',
    id: 'PIn3qA',
  },
  pageDescription: {
    description: 'Description text for the freight settings page',
    defaultMessage: 'Connect your LTL freight provider accounts to get quotes, book shipments, and manage freight from ShipStation.',
    id: 'uaJTc7',
  },
  connected: {
    description: 'Status label when a freight provider is connected',
    defaultMessage: 'Connected',
    id: 'juhy2L',
  },
  notConnected: {
    description: 'Status label when a freight provider is not connected',
    defaultMessage: 'Not Connected',
    id: 'xyPAyd',
  },
  connectButton: {
    description: 'Button label to connect a freight provider',
    defaultMessage: 'Connect',
    id: 'Y682lp',
  },
  disconnectButton: {
    description: 'Button label to disconnect a freight provider',
    defaultMessage: 'Disconnect',
    id: '6xZMNv',
  },
  connectedAt: {
    description: 'Label showing when a provider was connected',
    defaultMessage: 'Connected on {date}',
    id: 'iDSjVo',
  },
  providersTab: {
    description: 'Tab label for the freight providers list on the freight settings page',
    defaultMessage: 'Providers',
    id: 'o7xpGa',
  },
  invoicesTab: {
    description: 'Tab label for the freight invoices list on the freight settings page',
    defaultMessage: 'Invoices',
    id: 'oDNzYE',
  },
});

export const connectModalMessages = defineMessages({
  title: {
    description: 'Title for the connect freight provider modal',
    defaultMessage: 'Connect {providerName}',
    id: 'fyjUIe',
  },
  description: {
    description: 'Description text in the connect freight provider modal explaining where to find credentials',
    defaultMessage: 'Enter your SpeedShip API credentials. You can find your Client ID and Client Secret in your SpeedShip account portal.',
    id: 'nea/P1',
  },
  clientIdLabel: {
    description: 'Label for the Client ID input field in the connect freight provider modal',
    defaultMessage: 'Client ID',
    id: '2FWBj+',
  },
  clientSecretLabel: {
    description: 'Label for the Client Secret input field in the connect freight provider modal',
    defaultMessage: 'Client Secret',
    id: 'TMd6FJ',
  },
  cancelButton: {
    description: 'Cancel button label in the connect freight provider modal',
    defaultMessage: 'Cancel',
    id: 'vacp8Z',
  },
  connectButton: {
    description: 'Connect button label in the connect freight provider modal',
    defaultMessage: 'Connect',
    id: 'AJG9iK',
  },
  connectSuccess: {
    description: 'Success notification message after connecting a freight provider',
    defaultMessage: '{providerName} connected successfully.',
    id: '02dtPm',
  },
  connectError: {
    description: 'Error notification message when connecting a freight provider fails',
    defaultMessage: 'Failed to connect. Please check your credentials and try again.',
    id: 'DAfSUW',
  },
});
